import { cookiesStorage } from './cookiesStorage'

const apiErrorCodes = {
  AUTH_FAILED: 401,
  NORMAL_ERROR: 400,
  NOT_FOUND: 404,
  NETWORK_ERROR: 408,
  SERVER_ERROR: 503,
}

export interface ApiError {
  code: number
  data: { ERROR_CODE: number; MENSAJE_ERROR: string[] }
}

export const apiErrorService = {
  handleError: (error): ApiError => {
    const { response, code } = error

    if (code && code === 'ECONNABORTED') {
      return {
        code: Number(apiErrorCodes.NETWORK_ERROR),
        data: {
          ERROR_CODE: Number(apiErrorCodes.NETWORK_ERROR),
          MENSAJE_ERROR: ['NETWORK_ERROR'],
        },
      }
    }

    if (!response || !response.status) {
      return {
        code: Number(apiErrorCodes.SERVER_ERROR),
        data: {
          ERROR_CODE: Number(apiErrorCodes.SERVER_ERROR),
          MENSAJE_ERROR: ['INTERNAL_SERVER_ERROR'],
        },
      }
    }

    if (response.status === apiErrorCodes.AUTH_FAILED) {
      cookiesStorage.deleteAllCookies()
    }

    const errorCode = Object.keys(apiErrorCodes).find(apiErrorCode => response.status === apiErrorCodes[apiErrorCode])

    if (errorCode) {
      const MENSAJE_ERROR = response.data.errors.map(err => err.type)
      const ERROR_CODE = apiErrorCodes[errorCode]
      return {
        code: ERROR_CODE,
        data: {
          ERROR_CODE,
          MENSAJE_ERROR,
        },
      }
    }

    return {
      code: Number(apiErrorCodes.SERVER_ERROR),
      data: {
        ERROR_CODE: Number(apiErrorCodes.SERVER_ERROR),
        MENSAJE_ERROR: ['INTERNAL_SERVER_ERROR'],
      },
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/services/apiErrorService.ts